import React from "react";
import { DA_SearchInput } from "../SearchInput/SearchInput.component";
import S from "./MiniSearch.module.scss";

export const DA_MiniSearch = () => (
    <div className={S.wrapper}>
        <DA_SearchInput />
    </div>
);
